import {
    HttpResponse,
    MachineComponentModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class MachineComponentsDataService implements CrudService<MachineComponentModel, MachineComponentModel> {
    getAll(query: CrudDataQuery<MachineComponentModel>): Promise<CrudEnumerableResponse<MachineComponentModel>> {
        return ApiService.api.getMachineComponentBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<MachineComponentModel>): Promise<CrudEnumerableResponse<MachineComponentModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<MachineComponentModel>> {
        return ApiService.api.getMachineComponentById(id, params);
    }

    create(item: MachineComponentModel, params?: RequestParams): Promise<CrudResponse<MachineComponentModel>> {
        return ApiService.api.insertMachineComponent(item, params);
    }

    update(item: MachineComponentModel, params?: RequestParams): Promise<MachineComponentModel> {
        return ApiService.api.updateMachineComponent(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<MachineComponentModel> {
        return ApiService.api.patchMachineComponent(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<MachineComponentModel>): Promise<CrudEnumerableResponse<MachineComponentModel>> {
        return ApiService.api.deleteMachineComponents(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationMachineComponent(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<MachineComponentModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: MachineComponentModel, params?: RequestParams): Promise<CrudResponse<MachineComponentModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getMachineComponentGroupped(query, params);
    }

}

